import React, { useEffect, useState } from "react";

import { fetchHcfDetails } from "./api";
import { ShowError } from "../../../components/error";
import { Title } from "./title";
import { Value } from "./value";
import { Stack } from "@mui/material";
import { showErrorToast } from "@src/appV2/lib/Notifications";

function DisputeTerms({ hcfId, updateFacility }) {
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [details, setDetails] = useState<any>();
  const [error, setError] = useState();

  useEffect(() => {
    fetchHcfDetails(hcfId, "disputeTerms").then(setDetails).catch(setError);
  }, [hcfId]);

  const handleChange = (data) => {
    if (data && data?.disputeTerms > 99) {
      showErrorToast("Dispute terms value should not be greater than 99");
    } else {
      updateFacility({
        ...data,
        facilityId: hcfId,
      }).catch(() => showErrorToast("Unable to update workplace dispute terms"));
    }
  };

  return (
    <Stack>
      <Title>Dispute Terms</Title>
      <ShowError error={error} message="Unable to fetch workplace Dispute Terms" />
      <p className="content">
        This workplace has
        <Value name="disputeTerms" onChange={handleChange} value={details?.disputeTerms} />
        days from receipt of a Clipboard invoice to dispute the invoice contents
      </p>
    </Stack>
  );
}

export { DisputeTerms };
